exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".hide-test-frame {\n  position: absolute;\n  top: -9999px;\n  left: -9999px;\n  visibility: hidden;\n}\n", "", {"version":3,"sources":["/app/client/src/templates/Challenges/components/test-frame.css"],"names":[],"mappings":"AAAA;EACE,mBAAkB;EAClB,aAAY;EACZ,cAAa;EACb,mBAAkB;CACpB","file":"test-frame.css","sourcesContent":[".hide-test-frame {\n  position: absolute;\n  top: -9999px;\n  left: -9999px;\n  visibility: hidden;\n}\n"],"sourceRoot":""}]);

// exports
